import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateUserOnboarding } from '../../features/onboarding/onboarding.service';

// Create async thunk for updateUserOnboarding
export const updateUserOnboardingService = createAsyncThunk(
  'userOnboarding/updateUserOnboarding',
  async (payload: any, thunkAPI) => {
    return await updateUserOnboarding(payload.actionType, payload.value);
  }
);

const userOnboardingSlice = createSlice({
  name: 'userOnboarding',
  initialState: {
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateUserOnboardingService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserOnboardingService.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateUserOnboardingService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ? (action.payload as string) : null;
      });
  },
});

export default userOnboardingSlice.reducer;